module.exports = __webpack_public_path__ + "img/vest_1.82e10aa7.png";